import Vue from "vue";

export default {
  /**
   * Save Room Assignments in vuex state
   * @param state
   * @param {Array} assignments
   */
  setRoomAssignments(state, { assignments }) {
    state.roomAssignments = assignments;
  },

  /**
   * Update DigitalEventTableAssignment in RoomAssignments
   * @param state {Object}
   * @param assignmentId {Integer} DigitalEventTableAssignment.id
   * @param data {Object} New data
   */
  updateAssignment(state, { assignmentId, data }) {
    let assignment = state.roomAssignments.find(a => a.id === assignmentId);
    Object.assign(assignment, data.assignment);
  },

  /**
   * Update user info in the room state
   * @param state {Object}
   * @param userUUID {String}
   * @param data {Object}
   */
  updateStateUserInfo(state, { userUUID, data }) {
    let userIndex = state.deState.findIndex(user => user.userUUID === userUUID);
    if (userIndex !== -1) {
      Vue.set(state.deState, userIndex, Object.assign(state.deState[userIndex], data));
    }
  },

  /**
   * Set Room state to the store
   * @param state {Object}
   * @param roomState {Array}
   * @param updatedAt {String} - ISO datetime
   */
  setRoomState(state, { users, updatedAt }) {
    if (state.deState && state.deState.length) {
      if (users.length) {
        users.forEach(user => {
          let index = state.deState.findIndex(item => item.userUUID === user.userUUID);
          index >= 0 ? Vue.set(state.deState, index, user) : state.deState.push(user);
        });
      }
    } else {
      Vue.set(state, "deState", users);
    }

    if (updatedAt !== state.deStateUpdatedAt) {
      state.deStateUpdatedAt = updatedAt;
    }
  },

  /**
   * Update deStateUpdatedAt value
   * @param state {Object}
   * @param updatedAt {String} - ISO datetime
   */
  setRoomStateUpdatedAt(state, { updatedAt }) {
    if (updatedAt !== state.deStateUpdatedAt) {
      state.deStateUpdatedAt = updatedAt;
    }
  },

  /**
   * Set active room slug
   * @param state
   * @param roomSlug {String}
   */
  setActiveRoom(state, roomSlug) {
    state.activeRoom = roomSlug;
  },

  /**
   * Set active room slug
   * @param state
   * @param rooms {Array}
   */
  setRooms(state, rooms) {
    state.rooms = rooms;
  }
};
